import React from "react";

export default class SocialsDemolition extends React.Component {

    render() 
    {   
        return (        
            <ul className="socials">
                <li>
                    <img className="logo-footer-img" src="/images/logo-demolition.webp" alt="Hometown logo"></img>
                </li>
                <li className="front-li social">
                    <a className="facebook" role="button" aria-label="facebbok" rel="noreferrer" href="https://www.facebook.com/HometownDemolitionContractors/" target="_blank"/>
                    <a className="twitter" role="button" aria-label="twitter" rel="noreferrer" href="https://twitter.com/HometownDemo" target="_blank"/>
                    <a className="pinterest" role="button" aria-label="pinterest" rel="noreferrer" href="https://www.pinterest.com/hometowndiytips/" target="_blank"/>          
                    <a className="youtube" role="button" aria-label="youtube" rel="noreferrer" href="https://www.youtube.com/channel/UCVlHIvd1yvOU1fT7d7YdZXg/videos" target="_blank"/>
                </li>
            </ul>
        );
    }
}